export default __webpack_public_path__ + "static/media/cashmerecover.ac8e0ff3.png";